export const colors = {
    primary: "#da1a2fff",
    secondary: "#1e222c",
    backgrond: "#17191f",
    textColor: "rgba(250, 250, 250, .9)",
}
// primary: "#fcac04",
